import Banks from "./Banks";
import { firebaseConfig } from "../config/firebaseInit";

const isDev = firebaseConfig.authDomain.includes("ayo-desenvolvimento");
const BASE_URL_PAYMENTS = isDev
  ? "https://payments.sandbox.pagcerto.com.br/"
  : "https://payments.pagcerto.com.br/";

const TOKEN_MASTER =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA5LzA5L2lkZW50aXR5L2NsYWltcy9hY3RvciI6IlVzZXIiLCJBcHBsaWNhdGlvbklkIjoiMTE1IiwiSG9sZGVySWQiOiI0MjQiLCJVc2VySWQiOiI0MjQiLCJMaW5rQ29kZSI6IjUwMjY0Njk2IiwiU2FsdCI6ImQ2MjA4MzJlMjUxNTQwYWQ5MTIwMzNjMGVmY2MxNTUwIiwiaXNzIjoiYTA3MzhjZGQiLCJhdWQiOiJlYTJiNDdlYWJjMDQzIn0.X8EMxU5x6esNKmCyStS6ALUV-SApj5HmYHx5QwXCPCc";

const TOKEN_LOJISTA =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA5LzA5L2lkZW50aXR5L2NsYWltcy9hY3RvciI6IlVzZXIiLCJBcHBsaWNhdGlvbklkIjoiMTE1IiwiSG9sZGVySWQiOiI0NzEiLCJVc2VySWQiOiI0NzEiLCJMaW5rQ29kZSI6IjA4ODc0NTc1IiwiU2FsdCI6IjllZDcyMDc5ODg3ODRjMTE4NDAwNjQwNTI5ZDVhMTEyIiwiaXNzIjoiYTA3MzhjZGQiLCJhdWQiOiJlYTJiNDdlYWJjMDQzIn0.gOohIIMyg0jGSwfuOFMhDvur3fy2AlgrEs_HTZGnNyA";

const TOKEN_LOJISTA_PROD =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA5LzA5L2lkZW50aXR5L2NsYWltcy9hY3RvciI6IlVzZXIiLCJBcHBsaWNhdGlvbklkIjoiNjUiLCJIb2xkZXJJZCI6IjEyMjU5IiwiVXNlcklkIjoiMTIyNTkiLCJMaW5rQ29kZSI6IjIzNTg3NjQzIiwiU2FsdCI6IjMwNzQ2YTg3OGU4OTRlMGRhMGIwNTFmOTQ2YzFiYjdhIiwiaXNzIjoiODVlYTFmYzgiLCJhdWQiOiJhYjQxNGFhMGE5MWVhIn0.mv5ykyG7bZeGl0umLkEIlno9JZLblPrgw8VwuOOzpEE";

const DEFAULT_HEADERS = {
  Authorization: `bearer ${firebaseConfig.authDomain.includes("ayo-desenvolvimento") ? TOKEN_LOJISTA : TOKEN_LOJISTA_PROD
    }`,
  "Content-Type": "application/json",
};

const DRIVER_STATUS = Object.freeze({
  APPROVED: "approved",
  REPROVED: "repproved",
  PENDING: "pending",
  BANNED: "banned",
  BLOCKED: "blocked",
});

const TRANSACTION_STATUS = Object.freeze({
  ROLLBACK: 'rolledback',
  CANCELED: 'canceled',
});

const CLOUD_FUNCTIONS_URL = isDev ?
  "https://us-central1-ayo-desenvolvimento.cloudfunctions.net/"
  : "https://us-central1-ayo-taxi.cloudfunctions.net/";

const DEFAULT_CITY_CENTER = "Sergipe_Aracaju_Lagarto";

const API_ENTREGAS = isDev
  ? "https://www.deliveries-api-dev.ayoapp.com.br"
  : "https://www.deliveries-api.ayoapp.com.br";

const API_ENTREGAS_SOCKET = isDev
  ? "www.deliveries-api-dev.ayoapp.com.br"
  : "www.deliveries-api.ayoapp.com.br";

const SOCKET_EVENTS = {
  order: {
    CANCELED: "order:canceled",
    UPDATED: "order:updated",
    REMOVE_DELIVERYMAN: "order:remove_deliveryman",
    WAITING_RETURN: "order:waiting_deliveryman_return",
    FINISHED: "order:finished",
    ACCEPTED: "order:accepted",
    GIVE_BACK: "order:returned",
  },
  deliveryman: {
    NEW_LOCATION: "deliveryman:new_location",
  },
};

const STATUS_PENDING_PAYMENT = ["overdue", "pending"];

const STORE_INVOICE_STATUS = Object.freeze({
  PAID: "paid",
  OVERDUE: "overdue",
  CANCELED: "canceled",
  PENDING: "pending",
  PROCESSING: "processing",
  ERROR: "error",
});

const COMPANY_STATUS = Object.freeze({
  APPROVED: "approved",
  BLOCKED: "blocked",
  INACTIVE: "inactive",
});

const PAYMENT_METHODS = Object.freeze({
  CREDIT_CARD: "credit_card",
  DEBIT_CARD: "debit_card",
  CASH: "cash",
  PAID: "paid",
  EXCHANGE: "exchange",
  HEALTH_INSURANGE: "health_insurance",
});

export {
  API_ENTREGAS,
  API_ENTREGAS_SOCKET,
  Banks,
  BASE_URL_PAYMENTS,
  CLOUD_FUNCTIONS_URL,
  COMPANY_STATUS,
  DEFAULT_CITY_CENTER,
  DEFAULT_HEADERS,
  DRIVER_STATUS,
  PAYMENT_METHODS,
  STATUS_PENDING_PAYMENT,
  SOCKET_EVENTS,
  STORE_INVOICE_STATUS,
  TOKEN_LOJISTA,
  TOKEN_MASTER,
  TRANSACTION_STATUS,
};
